import Environments from '@/views/configuration/Environments.vue'

const router = {
    path: '/envs',
    name: 'Environments',
    component: Environments,
    meta: {
        title: 'Environments'
    }
};

export default router
